module.exports = __webpack_public_path__ + "static/apprentice's-notes-7a2cb929353fea962b27890e7d30e2ce.png";